"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { buildErIdLabel } from "@/lib/marketing/compliance";
import { COOKIE_ERID } from "@/lib/marketing/utm";

/**
 * Renders the Russian ad-labeling banner at the top of any public page
 * when the visit was reached via a paid ad (erid parameter in URL
 * or tlr_erid cookie set by middleware).
 *
 * Mandatory under ФЗ «О рекламе» for all paid traffic from Russian ad platforms.
 */
export function AdLabelBanner() {
  const [erid, setErid] = useState<string | null>(null);

  useEffect(() => {
    // Check URL first (fresh landing), then cookie (retained across clicks)
    const params = new URLSearchParams(window.location.search);
    const urlErid = params.get("erid");
    if (urlErid) {
      setErid(urlErid);
      return;
    }
    const cookie = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_ERID}=([^;]+)`));
    if (cookie) setErid(cookie[1]);
  }, []);

  if (!erid) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between gap-3 text-[11px] text-amber-900">
          <span className="truncate">{buildErIdLabel(erid)}</span>
          <Link href="/legal/advertising" className="shrink-0 underline hover:text-amber-700">
            Más información
          </Link>
        </div>
      </div>
    </div>
  );
}
